const map = {
	"./badge-app-store-bg.webp": 87417,
	"./badge-app-store-cs.webp": 28928,
	"./badge-app-store-de-AT.webp": 34593,
	"./badge-app-store-hr.webp": 26556,
	"./badge-app-store-hu.webp": 85485,
	"./badge-app-store-ro.webp": 53169,
	"./badge-app-store-sk.webp": 38440
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46593;